// extracted by mini-css-extract-plugin
export default {"container":"clip-details_container__AOb4q","details":"clip-details_details__8kyBz","actions":"clip-details_actions__2Vpmu"};